import { Component, Input } from "@angular/core";

type accordionItemData = {
    id: string,
    title: string,
    content: string,
    iconPath?: string,
    isInnerHTML?:boolean
}

@Component({
    selector: 'app-poshvine-accordion',
    templateUrl: './accordion.component.html',
    styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent {

    @Input() public accordionItems: accordionItemData[] = [];

    public assetsPath = './../../../assets'

    constructor() {

    }
}